module.exports = __webpack_public_path__ + "img/arrow-up-sm.f7937763.svg";